/**
 * @desc 门店最新动态
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** store_id */
  store_id: number;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.GeneralHttpResponse<defs.store.PostsInfoVO>>(
    `/storeapi/api/v3/store/news`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<defs.store.PostsInfoVO>;
export default req;
